export default __webpack_public_path__ + "static/media/heating.3d7cca75.jpg";